import {Text} from 'src/v2/components/common';
import {useSelector} from 'src/v2/state/store';
import {message, useIntl} from '@sail/intl';

const messages = {
  terms: message<{
    merchant: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.setup_terms.message',

    description:
      'Dislaimer shown when customers are saving their payment method for future usage',

    defaultMessage:
      "By continuing, you'll be asked to approve payments from your crypto wallet today and in the future, according to {merchant}'s terms. You can revoke this approval at any time.",
  }),
};

export const SetupTerms = () => {
  const intl = useIntl();
  const businessName = useSelector(
    (state) => state.merchantBranding.businessName,
  );

  return (
    <Text type="caption" css={{textAlign: 'center', color: 'subdued'}}>
      {intl.formatMessage(messages.terms, {
        merchant: businessName,
      })}
    </Text>
  );
};
